export const BASE_PATH = "/stores";
export const NEW_BASE_PATH = "/s/";
export const NEW_BASE_PATH_WITH_WORKSPACE = "/w/";
export const ORDER_BASE_PATH = "/orders";
export const ESHOP_BRAND = "eshops";
export const SM_PROGRAM_ID = 2;
export const SM_PROGRAM_IDENTIFIER = "snacks";
export const SUPPORTED_LANGUAGES = ["en"];
export const DEFAULT_COUNTRY_SLUG = "us";
export const DEFAULT_LANG_SLUG = "en";
export const FOOTER_PLATFORM = "Stadium";
export const APP_NAME = "stadium";

export const TREAT_VARIANTS = {
  snacksOnly: "snack_only",
};

export const ZENDESK_POSITION_BOTTOM = "90px";

export const DATE_PICKER_FORMAT = "MM/DD/YYYY";

export const ZENDESK_POSITION_HIDE_BOTTOM = "-150px";
